(function () {
    "use strict";

    angular.module("app").directive("habilSearchContainer", SearchContainerDirective);    
    function SearchContainerDirective() {
        return {
            transclude: {
                "title": "?searchTitle",
                "form": "searchForm",
                "counter": "resultCount"
            },
            templateUrl: "@/searchContainer/searchContainer.html",
            // Add support for deafult collapsed status
            link: function (_scope, element, attr) {
                if (attr.collapsed !== undefined) {
                    element.find(".panel-collapse").collapse("hide");
                }
            }
        };
    }
})();
